export default "__VITE_ASSET__D5$gs1eR__"